import { useLayoutEffect, useState } from "react";

/**
 * Gets the width and height of the window while causing rerenders for resizing
 */
export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
};

// export const useContainerDimensions = (windowWidth) => {
//   const containerRef = useRef(null);
//   const [dimensions, setDimensions] = useState({
//     width: null,
//     height: null,
//   });
//   useLayoutEffect(() => {
//     setDimensions(
//       (containerRef.current &&
//         containerRef.current.getBoundingClientRect() &&
//         containerRef.current.getBoundingClientRect.toJSON()) ||
//         undefined
//     );
//   }, [containerRef]);
//   return { containerRef, dimensions };
// };



// WEBPACK FOOTER //
// ./resources/assets/js/app/ComparisonBars/SolarVsGridBars/SolarVsGridBars.hooks.js